import React from 'react';
import './DisputeDetailsSkeleton.css';

const DisputeDetailsSkeleton = () => {
  return (
    <div className="dispute-details-skeleton-container">
      <div className="dispute-details-skeleton-breadcrumb" />

      <div className="dispute-details-skeleton-header">
        <div className="dispute-details-skeleton-title" />
        <div className="dispute-details-skeleton-badge" />
      </div>

      <div className="dispute-details-skeleton-date" />

      <div className="dispute-details-skeleton-section">
        <div className="dispute-details-skeleton-section-title" />
        <div className="dispute-details-skeleton-grid">
          <div className="dispute-details-skeleton-field">
            <div className="dispute-details-skeleton-label" />
            <div className="dispute-details-skeleton-value" />
          </div>
          <div className="dispute-details-skeleton-field">
            <div className="dispute-details-skeleton-label" />
            <div className="dispute-details-skeleton-value-badge" />
          </div>
          <div className="dispute-details-skeleton-field">
            <div className="dispute-details-skeleton-label" />
            <div className="dispute-details-skeleton-value" />
          </div>
          <div className="dispute-details-skeleton-field">
            <div className="dispute-details-skeleton-label" />
            <div className="dispute-details-skeleton-value" />
          </div>
          <div className="dispute-details-skeleton-field">
            <div className="dispute-details-skeleton-label" />
            <div className="dispute-details-skeleton-value" />
          </div>
          <div className="dispute-details-skeleton-field">
            <div className="dispute-details-skeleton-label" />
            <div className="dispute-details-skeleton-value" />
          </div>
        </div>
      </div>

      <div className="dispute-details-skeleton-section">
        <div className="dispute-details-skeleton-section-title" />
        <div className="dispute-details-skeleton-grid">
          <div className="dispute-details-skeleton-field">
            <div className="dispute-details-skeleton-label" />
            <div className="dispute-details-skeleton-value-long" />
          </div>
          <div className="dispute-details-skeleton-field">
            <div className="dispute-details-skeleton-label" />
            <div className="dispute-details-skeleton-value-long" />
          </div>
          <div className="dispute-details-skeleton-field">
            <div className="dispute-details-skeleton-label" />
            <div className="dispute-details-skeleton-value" />
          </div>
          <div className="dispute-details-skeleton-field">
            <div className="dispute-details-skeleton-label" />
            <div className="dispute-details-skeleton-value" />
          </div>
        </div>
      </div>

      <div className="dispute-details-skeleton-section">
        <div className="dispute-details-skeleton-section-title" />
        <div className="dispute-details-skeleton-payment">
          <div className="dispute-details-skeleton-payment-row">
            <div className="dispute-details-skeleton-label" />
            <div className="dispute-details-skeleton-value" />
          </div>
          <div className="dispute-details-skeleton-payment-row">
            <div className="dispute-details-skeleton-label" />
            <div className="dispute-details-skeleton-value" />
          </div>
          <div className="dispute-details-skeleton-payment-row">
            <div className="dispute-details-skeleton-label" />
            <div className="dispute-details-skeleton-value" />
          </div>
        </div>
      </div>

      <div className="dispute-details-skeleton-actions">
        <div className="dispute-details-skeleton-button" />
        <div className="dispute-details-skeleton-button" />
      </div>
    </div>
  );
};

export default DisputeDetailsSkeleton;
